import { createIcon } from '../icon'
import NextArrowIcon from '../svg/NextArrowIcon'

export const NextArrowIconDefault = createIcon(NextArrowIcon)
